<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" *ngIf="!isServerError()">
  <div fxFlex="70%">
    <div>
      {{ message | translate }}
    </div>
  </div>
  <div fxFlex="30%">
    <button class="close" style="float:right" mat-icon-button (click)="dismissSnackbar()" matTooltip="{{ 'close' }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div *ngIf="isServerError()" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="1 0 95" fxLayout="column" *ngIf="serverError.exceptionMessage; else genericError">
    <span fxFlex> ErrorMessage: {{ serverError.exceptionMessage }}</span>
  </div>
  <!-- <div fxFlex="1 0 95" fxLayout="column" *ngIf="serverError.statusCode; else genericError">
    <span fxFlex> ErrorCode: {{ serverError.statusCode }}</span>
    <span fxFlex> ErrorMessage: {{ serverError.message }}</span>
    <span fxFlex> Time: {{ serverError.timestamp }}</span>
  </div> -->
  <ng-template #genericError>
    <div fxFlex="1 0 95">
      {{ 'Some thing went wrong' }}
    </div>
  </ng-template>
  <button class="close" style="float:right" fxFlex="0 0 5" mat-icon-button (click)="dismissSnackbar()"
    matTooltip="{{ 'close' }}">
    <mat-icon>close</mat-icon>
  </button>
</div>